import { render, staticRenderFns } from "./OrderChart.vue?vue&type=template&id=3bed6c16&scoped=true&"
import script from "./OrderChart.vue?vue&type=script&lang=js&"
export * from "./OrderChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderChart.vue?vue&type=style&index=0&id=3bed6c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed6c16",
  null
  
)

component.options.__file = "OrderChart.vue"
export default component.exports